import logger from "../utils/logger";
import { ServiceRequest } from "./axios";

const apiService = async (endPoint, data) => {
  try {
    const payload = { ...endPoint };
    if (data?.bodyData) {
      payload.bodyData = data?.bodyData;
    }
    if (data?.queryParams) {
      payload.queryParams = data?.queryParams;
    }
    if (data?.formHeaders) {
      payload.formHeaders = data?.formHeaders;
    }
    if (data?.cancelRequest) {
      payload.cancelRequest = data?.cancelRequest;
    }
    payload.cancelFunction = () => {};
    const res = await ServiceRequest(payload);
    return res;
  } catch (error) {
    logger(error);
    throw new Error(error);
  }
};

export default apiService;
